export enum RoadmapItemStatus {
  DONE = "done",
  LOADING = "loading"
}
